import {
  IMPACT_CLICK_PARAM,
  IMPACT_SHARED_ID_PARAM,
  US_COUNTRY_CODE,
  US_PHONE_DIGIT_LENGTH,
} from "@constants";

/**
 * The phone number an Impact link carried in its `sharedid`, as ten digits, or null.
 *
 * Takes the query string Impact redirected to. Anything that is not an Impact landing, or whose
 * shared id is not a US phone number, yields null: affiliates also use `sharedid` for their own
 * sub-ids, and those must not be texted a code.
 */
export const getImpactPhoneNumber = (search: string): string | null => {
  const params = new URLSearchParams(search);

  if (params.get(IMPACT_CLICK_PARAM) !== "1") return null;

  const sharedId = params.get(IMPACT_SHARED_ID_PARAM)?.trim();

  // Digits and phone punctuation only, so a sub-id like `blog-2024-5551234567` is not mistaken
  // for a number once its letters are stripped.
  if (!sharedId || !/^[\d\s()+.-]+$/.test(sharedId)) return null;

  const digits = sharedId.replace(/\D/g, "");

  if (digits.length === US_PHONE_DIGIT_LENGTH) return digits;

  if (digits.length === US_PHONE_DIGIT_LENGTH + 1 && digits.startsWith(US_COUNTRY_CODE)) {
    return digits.slice(1);
  }

  return null;
};
